<script>
    import LoadingIcon from "./LoadingIcon.svelte";
    import {changeHandlerPassword, addAccount, setPrivateAnalyzeHandler} from "../lib/ApiRequests.svelte";
    import {_} from '../lib/i18n';

    export let analyze;
    export let analyzeInProgress;
    export let show = false;

    let login = (analyze && analyze.handler) ? analyze.handler.login : '';
    let password;
    let errors = [];
    let isLoading = false;
    let showPass = false;

    let handlerUsername;
    $: handlerUsername = (analyze && analyze.handler ? analyze.handler.login : '');

    let handlerAccountId;
    $: handlerAccountId = (analyze && analyze.handler ? analyze.handler.id : '');

    let targetUsername;
    $: targetUsername = (analyze && analyze.account ? analyze.account.username : '');

    async function setPassword() {
        isLoading = true;
        errors = [];

        if (analyze.handler.login === login) {
            const changePasswordResponse = await changeHandlerPassword(analyze.handler.id, password);
            if (changePasswordResponse.status === 'ok') {
                analyze.isPasswordError = false;
                analyze.handler.password = password;
                analyze.changeKeyValue('isPasswordError', false);
                analyze.changeKeyValue('handler', analyze.handler);
                analyze = analyze;
                show = false;
            }
        } else {
            const newHandler = {
                login,
                password
            }
            const addAccountResponse = await addAccount(newHandler.login, newHandler.password);
            if (addAccountResponse.result !== 'ok') {
                if (addAccountResponse.errors.length === 0) {
                    errors.push( $_('passwordErrorAlert.unknownError'));
                } else {
                    for (let key in addAccountResponse.errors) {
                        for (let i = 0; i < addAccountResponse.errors[key].length; i++) {
                            errors.push(addAccountResponse.errors[key][i]);
                        }
                    }
                }
                errors = errors;
            } else {
                const setHandlerResponse = await setPrivateAnalyzeHandler(analyze.id, addAccountResponse.id);
                if (setHandlerResponse.status === 'ok') {
                    newHandler.id = addAccountResponse.id;
                    analyze.is_not_friend = false;
                    analyze.isPasswordError = false;
                    analyze.handler = newHandler;
                    analyze.changeKeyValue('is_not_friend', false);
                    analyze.changeKeyValue('handler', newHandler);
                    analyze.changeKeyValue('isPasswordError', false);
                    analyze = analyze;
                    show = false;
                }
            }
        }

        isLoading = false;
    }

</script>

{#if show}
    <section class="private-acc-block system-info system-info_red" id="private-incorrect-data">
        <div class="private-acc-block__title-wrapper system-info__title-wrapper">
            <div class="private-acc-block__title-icon system-info__title-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="6.25" cy="6.25" r="1" fill="#C93329"></circle>
                    <circle cx="10" cy="6.25" r="1" fill="#C93329"></circle>
                    <circle cx="13.75" cy="6.25" r="1" fill="#C93329"></circle>
                    <path d="M7.49992 14.5833C7.49992 15.7339 6.56718 16.6667 5.41659 16.6667C4.26599 16.6667 3.33325 15.7339 3.33325 14.5833C3.33325 13.4327 4.26599 12.5 5.41659 12.5C6.56718 12.5 7.49992 13.4327 7.49992 14.5833ZM7.49992 14.5833H12.6041M15.8333 16.6667V14.7917C15.8333 14.6766 15.74 14.5833 15.6249 14.5833M12.6041 14.5833H15.6249M12.6041 14.5833V16.6667Mnan nanL15.6249 14.5833M15.6249 14.5833Lnan nan" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <rect x="2.5" y="3.3335" width="15" height="5.83333" rx="2" stroke="#C93329" stroke-width="2"></rect>
                </svg>
            </div>
            <h3 class="private-acc-block__title-text system-info__title-text">{$_('passwordErrorAlert.title')}</h3>
        </div>
        <p class="private-acc-block__text system-info__text">
            {@html $_('passwordErrorAlert.description', {
                values: { targetUsername, handlerUsername },
            })}
        </p>

        <div class="private-acc-block__form form">
            <input type="text" class="private-acc-block__input general-input" placeholder={$_('passwordErrorAlert.loginInputPlaceholder')} bind:value={login} />
            <div class="relative_block">
                {#if showPass}
                    <input type="text" class="private-acc-block__input general-input"
                           placeholder={$_('passwordErrorAlert.passwordInputPlaceholder')}
                           bind:value={password}/>
                {:else}
                    <input type="password" class="private-acc-block__input general-input"
                           placeholder={$_('passwordErrorAlert.passwordInputPlaceholder')}
                           bind:value={password}/>
                {/if}
                <span on:click={() => {showPass = !showPass}} class="eye_pass">
                {#if showPass}
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3L15 15" stroke="black" stroke-width="2" stroke-linecap="round" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.45176 4.36597C3.07891 5.27491 1.99401 6.58339 1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15C10.7255 15 12.3269 14.4703 13.6508 13.565L12.5673 12.4815C11.532 13.1271 10.3094 13.5 9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75071 8.69352C3.30705 7.33514 4.29303 6.19899 5.53922 5.45344L4.45176 4.36597ZM6.922 6.83622C6.35371 7.38212 6 8.14975 6 9C6 10.6569 7.34315 12 9 12C9.85025 12 10.6179 11.6463 11.1638 11.078L10.1027 10.0169C9.82862 10.314 9.43604 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.56396 7.68605 8.17138 7.9831 7.89731L6.922 6.83622ZM11.9988 9.08462L8.91538 6.00117C8.94349 6.00039 8.9717 6 9 6C10.6569 6 12 7.34315 12 9C12 9.0283 11.9996 9.05651 11.9988 9.08462ZM14.0937 11.1795C14.5746 10.6269 14.9672 9.99527 15.2493 9.30648C15.3297 9.11022 15.3297 8.88978 15.2493 8.69352C14.2411 6.23185 11.8219 4.5 9 4.5C8.50822 4.5 8.02868 4.5526 7.5667 4.65249L6.34928 3.43507C7.18113 3.153 8.07263 3 9 3C12.4516 3 15.4064 5.11944 16.6374 8.12502C16.867 8.6856 16.867 9.31441 16.6374 9.87499C16.2794 10.7491 15.7756 11.5482 15.1562 12.242L14.0937 11.1795Z" fill="black" />
                    </svg>
                {:else}
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.05667 9.59073L1.36262 9.87499L2.05667 9.59073ZM2.75072 8.69352C3.75892 6.23184 6.1781 4.5 9 4.5V3C5.54839 3 2.59359 5.11944 1.36262 8.12501L2.75072 8.69352ZM9 4.5C11.8219 4.5 14.2411 6.23185 15.2493 8.69352L16.6374 8.12502C15.4064 5.11944 12.4516 3 9 3V4.5ZM15.2493 9.30648C14.2411 11.7682 11.8219 13.5 9 13.5V15C12.4516 15 15.4064 12.8806 16.6374 9.87499L15.2493 9.30648ZM9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648L1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15V13.5ZM15.2493 8.69352C15.3297 8.88978 15.3297 9.11022 15.2493 9.30648L16.6374 9.87499C16.867 9.31441 16.867 8.6856 16.6374 8.12502L15.2493 8.69352ZM1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499L2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75072 8.69352L1.36262 8.12501Z"
                              fill="black"/>
                        <circle cx="9" cy="9" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                {/if}
            </span>
            </div>
            <button class="button button_ghost private-acc-block__form-btn" disabled={isLoading} on:click={setPassword}>
                <LoadingIcon show={isLoading} width="16" height="16" />
                {$_('passwordErrorAlert.authorize')}
            </button>
            {#if errors.length > 0}
                {#each errors as error}
                    <p class="system-info__error private-acc-block__error">{error}</p>
                {/each}
            {/if}
        </div>
        <p class="private-acc-block__text system-info__text">{$_('passwordErrorAlert.warning')}</p>
    </section>
{/if}

<style>
    .relative_block {
        position: relative;
        margin-bottom: 12px;
        & input {
            width: 100%;
              margin: 0 0 16px !important;
        }
    }
    .eye_pass {
        position: absolute;
        right: 10px;
        top: 0;
        display: flex;
        align-items: center;
        height: 100%;
    }
</style>